import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type CommunitiesRequestParams = paths['/v3/communities']['get']['parameters']['query'];
type ResponseType = paths['/v3/communities']['get']['responses']['200']['content']['application/json'];

export const getCommunities = async ({ config: { params } }: ConfigRequest<CommunitiesRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.community.find, {
    params,
  });
